<!--
  语言切换器
  用途：在中文 / 英文 / 西班牙语之间切换，并记住用户选择
  用法：放在顶部导航右侧；点击按钮即可切换，页面文案即时更新
-->
<template>
  <div class="lang-switcher" :aria-label="t('lang.label')">
    <button
      v-for="item in SUPPORTED_LOCALES"
      :key="item.code"
      type="button"
      class="lang-btn"
      :class="{ active: locale === item.code }"
      @click="onSwitch(item.code)"
    >
      {{ t(item.labelKey) }}
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { setLocale, SUPPORTED_LOCALES } from '@/i18n'

const { t, locale } = useI18n()

/** 切换语言：更新 i18n + localStorage */
const onSwitch = (code) => {
  setLocale(code)
}
</script>

<style scoped>
.lang-switcher {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: var(--color-bg-muted);
  border: 1px solid var(--color-border);
}

.lang-btn {
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 999px;
  cursor: pointer;
  line-height: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.lang-btn:hover {
  color: var(--color-primary);
}

.lang-btn.active {
  background: var(--color-primary);
  color: #fff;
}

@media (max-width: 640px) {
  .lang-btn {
    padding: 6px 8px;
    font-size: 11px;
  }
}
</style>
